'use client';

import React from 'react';
import { Button } from '@/components/ui/button';
import { Calendar, Clock, CalendarDays } from 'lucide-react';

export type TimeFilterOption =
	| 'all'
	| 'this-week'
	| 'this-month'
	| 'next-month';

interface TimeFilterProps {
	selectedFilter: TimeFilterOption;
	onFilterChange: (filter: TimeFilterOption) => void;
}

const timeFilterOptions = [
	{
		id: 'all' as TimeFilterOption,
		label: 'All Events',
		icon: Calendar,
		description: 'Show all upcoming events',
	},
	{
		id: 'this-week' as TimeFilterOption,
		label: 'This Week',
		icon: Clock,
		description: 'Events happening this week',
	},
	{
		id: 'this-month' as TimeFilterOption,
		label: 'This Month',
		icon: CalendarDays,
		description: 'Events happening this month',
	},
	{
		id: 'next-month' as TimeFilterOption,
		label: 'Next Month',
		icon: CalendarDays,
		description: 'Events happening next month',
	},
];

export function TimeFilter({
	selectedFilter,
	onFilterChange,
}: TimeFilterProps) {
	return (
		<div className='flex flex-col gap-3'>
			<h3 className='text-lg font-semibold text-foreground'>When</h3>
			<div className='flex gap-2 overflow-x-auto pb-2 px-1 no-scrollbar'>
				{timeFilterOptions.map((option) => {
					const Icon = option.icon;
					const isSelected = selectedFilter === option.id;

					return (
						<Button
							key={option.id}
							variant={isSelected ? 'default' : 'outline'}
							size='sm'
							onClick={() => onFilterChange(option.id)}
							className={`flex items-center gap-2 transition-all duration-200 whitespace-nowrap min-w-fit px-3 py-2 ${
								isSelected
									? 'bg-primary text-primary-foreground shadow-md hover:bg-primary/90'
									: 'hover:bg-accent hover:text-accent-foreground border-border/50'
							}`}
							title={option.description}
						>
							{/*<Icon className='w-4 h-4 flex-shrink-0' />*/}
							<span className='text-sm'>{option.label}</span>
						</Button>
					);
				})}
			</div>
		</div>
	);
}
